<template>
  <div uk-slider="finite: false; sets: true">

    <div class="uk-position-relative uk-visible-toggle uk-light" tabindex="-1">

        <ul class="uk-slider-items uk-child-width-1-3@s uk-grid">
            <li v-for="item in articles" :key="item.slug">
                <div class="uk-card uk-card-default">
                  <div class="uk-card-badge uk-label">{{ item.category && item.category.class ? item.category.class.name : '' }}</div>
                  <div class="uk-card-media-top">
                      <img :src="api_url + item.cover.formats.small.url" alt="">
                  </div>
                  <div class="uk-card-body">
                      <div class="uk-card-title truncate-2">
                        <a :href="`/${item.slug}?class=${item.category && item.category.class ? item.category.class.name : ''}`" style="color: #666;">{{ item.title }}</a>
                      </div>
                      <div class="uk-panel uk-panel-box truncate-4">{{ item.summary }}</div>
                  </div>
                </div>
            </li>
        </ul>

        <a class="uk-position-center-left uk-position-small uk-hidden-hover" href="#" uk-slidenav-previous uk-slider-item="previous"></a>
        <a class="uk-position-center-right uk-position-small uk-hidden-hover" href="#" uk-slidenav-next uk-slider-item="next"></a>

    </div>

    <ul class="uk-slider-nav uk-dotnav uk-flex-center uk-margin"></ul>

  </div>

</template>

<script>
export default {
  data: function() {
    return {
      api_url: process.env.VUE_APP_STRAPI_API_URL
    };
  },
  props: {
    articles: Array
  },
};
</script>

<style scoped>
  .article-card{
    max-width: 400px;
  }
  .truncate-4{
    display: -webkit-box;
    -webkit-box-orient: vertical;

    /* to specify the number of lines you want the text to run through... */
    -webkit-line-clamp: 4;
    /* hide the overflowing text, i.e, texts that did not fit in to the box */
    overflow: hidden;
  }
  .truncate-2{
    display: -webkit-box;
    -webkit-box-orient: vertical;

    /* to specify the number of lines you want the text to run through... */
    -webkit-line-clamp: 2;
    /* hide the overflowing text, i.e, texts that did not fit in to the box */
    overflow: hidden;
  }
  .link{
    color: #000;
  }
</style>